import { render, staticRenderFns } from "./CategoriesSideBar.vue?vue&type=template&id=4706ba10&scoped=true"
import script from "./CategoriesSideBar.vue?vue&type=script&lang=js"
export * from "./CategoriesSideBar.vue?vue&type=script&lang=js"
import style0 from "./CategoriesSideBar.vue?vue&type=style&index=0&id=4706ba10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4706ba10",
  null
  
)

export default component.exports